import Button from "@mui/material/Button";
import { useState } from "react";
import SimpleDialog from "../../../common/SimpleDialog";
import StarIcon from '@mui/icons-material/Star';
import IconButton from "@mui/material/IconButton";
import useICPWizard from "../hooks/useICPWizard";
import SelectICPFilters from "./SelectICPFilters";
import { Sprint } from "../../../../stores/SprintStore";
import ICPWizardSteps from "./ICPWizardSteps";
import RefineICPFilters from "./RefineICPFilters";
import ICPDetails from "./ICPDetails";
import ICPAssignLeadList from "./ICPAssignLeadList";
import ICPCadenceOptions from "./ICPCadenceOptions";
import ICPSelect from "./ICPSelect";

type Props = {
    sprint: Sprint,
    onClosed: () => void,
}

const ICPWizard = ({ sprint, onClosed }: Props) => {
    const [open, setOpen] = useState(false);
    /*const [open, setOpen] = useState(sprint.id === '592f6a66-d68b-4b6f-af5d-4010e3b924db');*/
    const { step, createIcp, reset } = useICPWizard();

    const handleOpen = () => {
        createIcp(sprint);
        setOpen(true);
    }

    const handleCancel = () => {
        setOpen(false);
        onClosed();
    }

    const handleSaved = (loadAssignLeads: boolean) => {
        setOpen(false);
        onClosed();
    }

    return (
        <>
            <IconButton size="small" onClick={handleOpen} title='Create Ideal Customer Profile (ICP)' role="create ICP">
                <StarIcon />
            </IconButton>
            {open && <SimpleDialog open={open} onClose={handleCancel} size='xl'>
                {step === 0 && <ICPSelect
                    onCancel={handleCancel}
                />}
                {step === 1 && <SelectICPFilters onCancel={reset} steps={<ICPWizardSteps stepNumber={step - 1} />} />}
                {step === 2 && <RefineICPFilters
                    onCancel={reset}
                    steps={<ICPWizardSteps stepNumber={step - 1} />}
                />}
                {step === 3 && <ICPDetails
                    onCancel={reset}
                    onSaved={handleSaved}
                    steps={<ICPWizardSteps stepNumber={step - 1} />}
                />}
                {step === 4 && <ICPAssignLeadList
                    steps={<ICPWizardSteps stepNumber={step - 1} />}
                    onClose={handleCancel}
                />}
                 
            </SimpleDialog>}
        </>
    )
}

export default ICPWizard;